import { observer } from 'mobx-react';

import { useStores } from '../../../../stores/useStores';
import { useMetagameWidgetData } from '../../hooks/useMetagameWidgetData';
import type { MetagameWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { MetagameSmallWidget } from './MetagameSmallWidget/MetagameSmallWidget';
import { MetagameWideWidget } from './MetagameWideWidget/MetagameWideWidget';
import { MetagameWidgetTimer } from './MetagameWidgetTimer/MetagameWidgetTimer';

interface MetagameWidgetProps {
  sizeType: WidgetSizeType;
  data: MetagameWidgetDataType;
}

function MetagameWidgetComponent(props: MetagameWidgetProps) {
  const { coinTypeStore } = useStores();
  const coinType = coinTypeStore.coinType;
  const { data, sizeType } = props;
  const { event, metagameType } = data;
  const eventByCoin = event[coinType.toLowerCase() as 'gc' | 'sc'];

  const { widgetImageUrl, balanceValue, onTimerEnd, handleClick } = useMetagameWidgetData({ event, eventByCoin });

  if (!eventByCoin) {
    return null;
  }

  const timer = (
    <MetagameWidgetTimer endDate={new Date(event.endDate)} extended={sizeType === 'wide'} onEnd={onTimerEnd} />
  );

  return (
    <WidgetWrapper smallWidgetExtended sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <MetagameSmallWidget balanceValue={balanceValue} timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <MetagameWideWidget
          balanceValue={balanceValue}
          metagameType={metagameType}
          timer={timer}
          widgetImageUrl={widgetImageUrl}
        />
      )}
    </WidgetWrapper>
  );
}

export const MetagameWidget = observer(MetagameWidgetComponent);
